import { IconComponent } from './types';

const MountainIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_615_6316)">
      <path
        d="M6.9 7.2L7.3 6.9L7 6.5L5.67045 4.72727L7.09091 2.83333L11 8.04545H5.77273L6.02727 7.85455L6.9 7.2ZM5.54578 8.04545H1L3.27259 5.01533L3.75427 5.65789C4.25269 6.32268 4.86644 7.14101 5.32749 7.75483L5.54578 8.04545Z"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_615_6316">
        <rect width="12" height="12" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default MountainIcon;
